function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Alert, Button, Space, Card, Row as AntRow, Col as AntCol, Modal, notification, Result, Divider } from "antd";
import { Col, Row, Container } from "react-bootstrap";
import { ArrowLeftCircleFill, PlusLg, EyeFill, PersonFillAdd, PenFill, TrashFill, ArrowClockwise, CheckCircleFill, AwardFill, PeopleFill, Cash } from "react-bootstrap-icons";
import Common from '../../components/includes/Common';
import AddContestMilestone from '../admin-forms/AddContestMilestone';
import AddContestCandidate from '../admin-forms/AddContestCandidate';
import EditContestMilestone from '../admin-forms/EditContestMilestone';
import ContestMilestoneReport from '../admin-components/ContestMilestoneReport';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Meta = Card.Meta;
var ContestSummary = function ContestSummary() {
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    contextHolder = _Modal$useModal2[1];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    contest = _useState2[0],
    setContest = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dataChanged = _useState6[0],
    setDataChanged = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedMilestone = _useState10[0],
    setSelectedMilestone = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showAddContestant = _useState12[0],
    setShowAddContestant = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showAddMilestone = _useState14[0],
    setShowAddMilestone = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showEditMilestone = _useState16[0],
    setShowEditMilestone = _useState16[1];
  var _useState17 = useState(),
    _useState18 = _slicedToArray(_useState17, 2),
    showContestReport = _useState18[0],
    setShowContestReport = _useState18[1];
  var _useState19 = useState(0),
    _useState20 = _slicedToArray(_useState19, 2),
    totalVoteCount = _useState20[0],
    setTotalVote = _useState20[1];
  var _useParams = useParams(),
    id = _useParams.id;
  var switchMilestoneStatus = function switchMilestoneStatus(m) {
    setSelectedMilestone(m);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: [m.status == 0 ? "L'arret" : "La reprise", " de l'\xE9tape ", m.label, " ? "]
      }),
      onOk: function onOk() {
        axios.get("".concat(Common.baseApiUrl, "switchcontestmilestonestatus/").concat(m.id, "/").concat(Common.currentUser.id)).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              description: response.data.message
            });
            setDataChanged(true);
          } else notification.error({
            message: "Erreur!",
            description: response.data.message
          });
        })["catch"](function (error) {
          notification.error({
            message: "Erreur!",
            description: "Une erreur est survenue"
          });
        })["finally"](function () {});
      }
    });
  };
  useEffect(function () {
    setDataChanged(false);
    setIsDataLoading(true);
    setErrorMessage("");
    if (id == null) return;
    axios.get(Common.baseApiUrl + "getcontest/" + id + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setContest(response.data.contest);
        response.data.contest.contest_milestones.forEach(function (m) {
          setTotalVote(function (prev) {
            return prev + m.votes.length;
          });
        });
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue " + error.toString());
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Row, {
      style: {
        margin: "15px 0px"
      },
      children: /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsxs(Button, {
            type: "link",
            onClick: function onClick() {
              history.back();
            },
            icon: /*#__PURE__*/_jsx(ArrowLeftCircleFill, {}),
            size: "middle",
            children: [" ", /*#__PURE__*/_jsx("b", {
              children: " RETOUR"
            })]
          }), /*#__PURE__*/_jsxs(Button, {
            type: "link",
            onClick: function onClick() {
              setShowAddMilestone(true);
            },
            size: "middle",
            children: [" ", /*#__PURE__*/_jsx("b", {
              children: " AJOUTER UNE ETAPE"
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        lg: 9,
        md: 9,
        children: /*#__PURE__*/_jsx(AntRow, {
          gutter: 16,
          children: contest && contest.contest_milestones.map(function (m) {
            return /*#__PURE__*/_jsx(AntCol, {
              span: 8,
              children: /*#__PURE__*/_jsxs(Card, {
                hoverable: true,
                style: {
                  width: 240,
                  marginBottom: "12px"
                },
                cover: /*#__PURE__*/_jsx("img", {
                  src: m.cover_url
                }),
                actions: [/*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    setSelectedMilestone(m);
                    setShowContestReport(true);
                  },
                  children: /*#__PURE__*/_jsx(EyeFill, {
                    size: 16
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    setSelectedMilestone(m);
                    setShowAddContestant(true);
                  },
                  children: /*#__PURE__*/_jsx(PersonFillAdd, {
                    size: 16
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    setSelectedMilestone(m);
                    setShowEditMilestone(true);
                  },
                  children: /*#__PURE__*/_jsx(PenFill, {
                    size: 15
                  })
                }), /*#__PURE__*/_jsxs(_Fragment, {
                  children: [contextHolder, /*#__PURE__*/_jsx(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setSelectedMilestone(m);
                      confirm({
                        title: /*#__PURE__*/_jsx("b", {
                          children: "Confirmez-vous ?"
                        }),
                        content: /*#__PURE__*/_jsxs("p", {
                          children: ["La suppression, de l'\xE9tape ", m.label]
                        }),
                        onOk: function onOk() {
                          axios.get("".concat(Common.baseApiUrl, "deletecontestmilestone/").concat(m.id, "/").concat(Common.currentUser.id)).then(function (response) {
                            if (response.data.status == 200) {
                              notification.success({
                                message: "Ok!",
                                description: "Etape supprimée"
                              });
                              setDataChanged(true);
                            } else notification.error({
                              message: "Erreur!",
                              description: response.data.message
                            });
                          })["catch"](function (error) {
                            notification.error({
                              message: "Erreur!",
                              description: "Une erreur est survenue"
                            });
                          })["finally"](function () {});
                        }
                      });
                    },
                    children: /*#__PURE__*/_jsx(TrashFill, {
                      size: 15
                    })
                  })]
                }), /*#__PURE__*/_jsx(_Fragment, {
                  children: m.status == 1 ? /*#__PURE__*/_jsxs(_Fragment, {
                    children: [contextHolder, /*#__PURE__*/_jsx(Button, {
                      type: "link",
                      onClick: function onClick() {
                        switchMilestoneStatus(m);
                      },
                      children: /*#__PURE__*/_jsx(ArrowClockwise, {
                        size: 16
                      })
                    })]
                  }) : /*#__PURE__*/_jsxs(_Fragment, {
                    children: [contextHolder, /*#__PURE__*/_jsx(Button, {
                      type: "link",
                      onClick: function onClick() {
                        switchMilestoneStatus(m);
                      },
                      children: /*#__PURE__*/_jsx(CheckCircleFill, {
                        size: 16
                      })
                    })]
                  })
                })],
                children: [/*#__PURE__*/_jsx(Meta, {
                  title: m.label,
                  description: /*#__PURE__*/_jsx(_Fragment, {})
                }), /*#__PURE__*/_jsx("div", {
                  children: /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 6,
                      md: 6,
                      sm: 6,
                      xs: 6,
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsx(AwardFill, {
                          style: {
                            color: "#A14C44"
                          },
                          size: 20
                        }), /*#__PURE__*/_jsx("span", {
                          style: {
                            color: "#A14C44"
                          },
                          children: "0"
                        })]
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 6,
                      md: 6,
                      sm: 6,
                      xs: 6,
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsx(PeopleFill, {
                          size: 20
                        }), /*#__PURE__*/_jsx("span", {
                          children: m.contest_milestone_candidates.length
                        })]
                      })
                    })]
                  })
                })]
              })
            });
          })
        })
      }), /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            background: "#FFFFFF",
            borderRadius: "6px",
            minHeight: "400px"
          },
          children: [contest && /*#__PURE__*/_jsx(Result, {
            icon: /*#__PURE__*/_jsx(AwardFill, {
              size: 65
            }),
            title: totalVoteCount + " votes",
            subTitle: "Le nombre total de votes pour toutes les \xE9tapes.",
            extra: /*#__PURE__*/_jsxs(_Fragment, {
              children: [contextHolder, /*#__PURE__*/_jsx(Button, {
                size: "large",
                onClick: function onClick() {
                  confirm({
                    title: /*#__PURE__*/_jsx("b", {
                      children: "Confirmez-vous ?"
                    }),
                    content: /*#__PURE__*/_jsx("p", {
                      children: "La fermeture de tous les votes ?"
                    }),
                    onOk: function onOk() {}
                  });
                },
                type: "primary",
                children: /*#__PURE__*/_jsx("b", {
                  children: "Fermer tous les votes"
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Result, {
            icon: /*#__PURE__*/_jsx(Cash, {
              size: 65
            }),
            title: totalVoteCount * 3000 + " GNF",
            subTitle: "Le montant total de des revenus."
          })]
        })
      })]
    }), showAddMilestone && contest && /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "AJOUTER UNE ETAPE/ UNE CATEGORIE"
      }),
      footer: null,
      destroyOnClose: true,
      open: showAddMilestone,
      onCancel: function onCancel() {
        setShowAddMilestone(false);
      },
      width: {
        xs: '95%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '40%'
      },
      children: /*#__PURE__*/_jsx(AddContestMilestone, {
        contest: contest,
        handler: function handler() {
          setShowAddMilestone(false);
          setDataChanged(true);
        }
      })
    }), selectedMilestone && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["AJOUTER UN(E) CANDIDAT(E) A ", selectedMilestone.label]
        }),
        footer: null,
        destroyOnClose: true,
        open: showAddContestant,
        onCancel: function onCancel() {
          setShowAddContestant(false);
        },
        width: {
          xs: '95%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%'
        },
        children: /*#__PURE__*/_jsx(AddContestCandidate, {
          milestone: selectedMilestone,
          handler: function handler() {
            setShowAddContestant(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Candidat(e) ajouté(e)"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "MODIFIER UNE ETAPE/ UNE CATEGORIE"
        }),
        footer: null,
        open: showEditMilestone,
        destroyOnClose: true,
        onCancel: function onCancel() {
          setShowEditMilestone(false);
        },
        width: {
          xs: '95%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%'
        },
        children: /*#__PURE__*/_jsx(EditContestMilestone, {
          milestone: selectedMilestone,
          handler: function handler() {
            setShowEditMilestone(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Etape modifié(e)"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: selectedMilestone.label
        }),
        footer: null,
        open: showContestReport,
        destroyOnClose: true,
        onCancel: function onCancel() {
          setShowContestReport(false);
        },
        width: {
          xs: '95%',
          sm: '80%',
          md: '80%',
          lg: '80%',
          xl: '75%',
          xxl: '70%'
        },
        children: /*#__PURE__*/_jsx(ContestMilestoneReport, {
          milestone_id: selectedMilestone.id
        })
      })]
    })]
  });
};
export default ContestSummary;